export default __webpack_public_path__ + "static/rosewood-150x150-207b0221f69d28479ba39b7e33c3c2b8.png";